<template>
  <h1 class="font-bold text-3xl mb-4">Verify Account</h1>
  IMPLEMENT
</template>

<script setup lang="ts"></script>
